module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-39-min.aa466e59.jpg";